import { useQuery } from '@tanstack/react-query';
import { opportunityService } from '../../../services/opportunityService';

export const opportunityQueryKey = (id: number) => ['opportunity', id] as const;

export const useOpportunityQuery = (id: number) =>
  useQuery({
    queryKey: opportunityQueryKey(id),
    queryFn: () => opportunityService.getById(id),
    staleTime: 60_000,
    enabled: id > 0,
  });
